export const fadeInAnimation = {
  duration: 0.7,
  ease: 'back',
  opacity: 0,
  y: '10px',
}

export const playerContainerEase = {
  ease: 'circ.inOut',
  duration: '0.6',
}

export const playerControlsScale = {
  duration: 0.2,
  scale: 0.9,
}
